import React from 'react';
import '../../App.css';
import SpButton from '../../components/atoms/SpButton';
import { useHistory } from 'react-router';
import { withSnackbar } from '../../components/atoms/SpSnackBar';
import { Grid } from '@material-ui/core';

const UserAdminDashboard = (props) => {
  //Hooks
  const history = useHistory();

  return (
    <>
      <Grid
        item
        container
        direction={'column'}
        spacing={3}
        justifyContent="flex-start"
        alignItems={'center'}
      >
        <Grid
          item
          xs={3}
        >
          <SpButton
            variant="standardMax"
            text={'STAZIONI UTENTI'}
            onClick={() => history.push('/admin/stations')}
          />
        </Grid>
        <Grid
          item
          xs={3}
        >
          <SpButton
            variant="standardMax"
            text={'UTENTI AMMINISTRATORI'}
            onClick={() => history.push('/admin/users')}
          />
        </Grid>
        <Grid
          item
          xs={3}
        >
          <SpButton
            variant="standardMax"
            text={'RICHIESTE DI ELIMINAZIONE'}
            onClick={() => history.push('/admin/delete-requests')}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default withSnackbar(UserAdminDashboard);
